import React from 'react';
import './Loading.css';

const Loading = () => {
  return (
    <div className="loading-container" role="status" aria-live="polite">
      <div className="loading-shell">
        <div className="loading-spinner" aria-hidden="true" />
        <p className="loading-title">Preparing TryInterview</p>
        <p className="loading-copy">Loading your next screen with a lighter, faster startup.</p>
      </div>
    </div>
  );
};

export default Loading;
